/**
 * Contexto da transcrição. Fica num arquivo próprio (sem importar o LiveKit nem a API) para quem só LÊ o estado
 * (botões, legenda, aviso, painel) não puxar o provedor junto.
 */
import { createContext, useContext } from 'react';

export const TranscriptContext = createContext(null);

/** `null` fora do provedor: a chamada não usa a Jev (convidado, chamada sem addon). */
export const useCallTranscript = () => useContext(TranscriptContext);
